import {backAdmin} from "../axios";

export const customersApi = [
    {url: `${backAdmin}/customers`, name: 'customers.all', method: 'GET'},
    {url: `${backAdmin}/customers/export`, name: 'customers.export', method: 'GET'},
    {url: `${backAdmin}/customers/delete`, name: 'customers.delete', method: 'PUT'},
    {url: `${backAdmin}/customers/{id}`, name: 'customers.by.id', method: 'GET'},
    {url: `${backAdmin}/customers/{id}/purchases`, name: 'customer.purchases', method: 'GET'},
    {url: `${backAdmin}/customers/invoice/{id}`, name: 'customer.download.invoice', method: 'GET'},
    {url: `${backAdmin}/customers/status`, name: 'customers.change.status', method: 'PUT'},
]